import { render, staticRenderFns } from "./AdminNotificationView.vue?vue&type=template&id=0d05db23"
import script from "./AdminNotificationView.vue?vue&type=script&lang=js"
export * from "./AdminNotificationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports